'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    DropdownSelectRow: {
        displayName: 'DropdownSelectRow'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/DropdownSelect/default/DropdownSelectRow.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var DropdownSelectRow = _wrapComponent('DropdownSelectRow')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(DropdownSelectRow, _Component);

    function DropdownSelectRow() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DropdownSelectRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownSelectRow.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelectRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
            e.preventDefault();
            var _this$props = _this.props,
                id = _this$props.id,
                selected = _this$props.selected,
                onClick = _this$props.onClick;

            if (!selected) {
                onClick(id);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DropdownSelectRow, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                text = _props.text,
                selected = _props.selected;

            return _react3.default.createElement(
                'li',
                { className: selected ? 'disabled' : '', onMouseDown: this.handleClick },
                _react3.default.createElement(
                    'a',
                    { disabled: selected, className: selected ? 'disabled' : '' },
                    text
                )
            );
        }
    }]);
    return DropdownSelectRow;
}(_react2.Component), _class.propTypes = {
    selected: _react2.PropTypes.bool.isRequired,
    onClick: _react2.PropTypes.func.isRequired,
    text: _react2.PropTypes.string.isRequired,
    id: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number, _react2.PropTypes.object]).isRequired
}, _temp2));

exports.default = DropdownSelectRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownSelect/default/DropdownSelectRow.jsx
// module id = 1656
// module chunks = 0